module.exports = __webpack_public_path__ + "img/public/SiteIcons/Show-up-arrow.svg?c8ef1bc7";